import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import DynamicPage from "./pages/DynamicPage";
import Navigation from "./components/Navigation";
import PreviewPage from "./pages/PreviewPage";
import Footer from "./components/Footer";

function App() {
  const useWindowWidth = () => {
    const [width, setWidth] = useState(window.innerWidth);
    useEffect(() => {
      const handleResize = () => setWidth(window.innerWidth);
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);
    return width;
  };

  const windowWidth = useWindowWidth();
  const isDesktop = windowWidth >= 992;
  const [darkMode, setDarkMode] = useState(false);
  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("dark-mode");
    } else {
      document.body.classList.remove("dark-mode");
    }
  }, [darkMode]);

  const toggleDarkMode = () => setDarkMode((prev) => !prev);

  const [pageLoading, setPageLoading] = useState(false);

  const [isPageLoaded, setIsPageLoaded] = useState(false);
  useEffect(() => {
    const handleLoad = () => setIsPageLoaded(true);
    if (document.readyState === "complete") {
      setIsPageLoaded(true);
    } else {
      window.addEventListener("load", handleLoad);
    }
    return () => window.removeEventListener("load", handleLoad);
  }, []);

  return (
    <>
      <div className="main-content">
        <Navigation />

        <Routes>
          <Route
            path="/"
            element={<DynamicPage isHome={true} setLoading={setPageLoading} />}
          />
          <Route
            path="/:pageSlug"
            element={<DynamicPage setLoading={setPageLoading} />}
          />
          <Route
            path="/frettir/:newsSlug"
            element={<DynamicPage setLoading={setPageLoading} />}
          />
          <Route path="/preview/:pageSlug" element={<PreviewPage />} />
        </Routes>
      </div>

      {!pageLoading && <Footer />}
      {isPageLoaded && <div className="trigger-footer" style={{ display: "block" }} />}
    </>
    // </CursorProvider>
  );
}

export default App;
